import React from 'react'
import './Scratch.css'

const Scratch = ({name, handleScratch}) => {
  return (
    <div className='scratch'>
      <img 
        className='scratchButton'
        src='./Scratches/scratch-icon.png' // https://www.shareicon.net/record-player-music-and-multimedia-lp-vinyl-technology-turntable-music-music-player-813432
        alt='record player'
        onClick={() => handleScratch(name)}
      />
    </div>
  )
}

export default Scratch


// WEBPACK FOOTER //
// ./src/Scratch/Scratch.js